<template>
  <v-card>
    <v-card-title class="align-center justify-center third white--text mb-4">Historique</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="computedHistory"
        :items-per-page="5"
        item-key="sk"
        :show-expand="true"
        :single-expand="true"
        @item-expanded="copyObservation"
      >
        <template #expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-row no-gutters class="my-6">
              <v-col cols="12">
                <v-textarea
                  v-model="newObservation"
                  outlined
                  no-resize
                  label="Observations"
                  style="width: 100%;"
                  hide-details
                  color="third"
                />
              </v-col>
              <v-col cols="12" class="d-flex justify-end mt-4">
                <v-btn color="third" class="white--text" :disabled="item.observation === newObservation" :loading="loadingObservation" @click="updateObservation(item)">
                  <span>Enregistrer</span>
                </v-btn>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { format, fromUnixTime } from 'date-fns';
import { sendNotification } from '@/helpers/utils';
import { changeContractHistoryObservation } from '@/helpers/request';

export default {
  props: {
    contractHistory: { type: Array, default: () => [] }
  },
  setup (props) {
    const loadingObservation = ref(false);
    const newObservation = ref(null);

    const headers = [
      { text: 'Date de modification du stock', value: 'date', width: '30%', align: 'center' },
      { text: 'Vieux stock', value: 'oldStock', width: '20%', align: 'center' },
      { text: 'Nouveau stock', value: 'newStock', width: '20%', align: 'center' },
      { text: 'Collaborateur', value: 'collaboratorUuid', width: '30%', align: 'center' }
    ];

    const computedHistory = computed(() => {
      return (props.contractHistory || [])
        .map(item => ({ ...item, date: format(fromUnixTime(item.timestamp), 'dd-MM-yyyy HH:mm') }))
        .sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1));
    });

    const updateObservation = async (history) => {
      loadingObservation.value = true;
      const response = await changeContractHistoryObservation({ ...history, newObservation: newObservation.value });
      loadingObservation.value = false;

      if (response.success) {
        sendNotification('success', 'Historique des stocks mis à jour avec succès.');
        const index = props.contractHistory.findIndex(h => h.sk === history.sk);
        if (index !== -1) {
          props.contractHistory[index].observation = newObservation.value;
        }
      } else {
        sendNotification('error', "Erreur lors de la mise à jour de l'historique des stocks.");
      }
    };

    const copyObservation = (event) => {
      if (!event.value) {
        newObservation.value = null;
        return;
      }
      newObservation.value = event.item.observation;
    };

    return { headers, computedHistory, loadingObservation, newObservation, updateObservation, copyObservation };
  }
};
</script>
